// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2fWCF","savePackageButton":"ClientWallet_savePackageButton__2O9Am"};